import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-black text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Tagline */}
          <div className="md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_push-life-rescue/artifacts/5u8zfaw3_8FDE4B3D-0199-4FB7-B27F-1E811EC96128.png" 
              alt="PUSH Training Logo" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 max-w-md">
              Empowering individuals with life-saving skills. 
              Prepare Until Success Happens.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-red-500 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-red-500 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-red-500 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/policy" className="text-gray-400 hover:text-red-500 transition-colors">
                  Policies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin size={20} className="text-red-500 flex-shrink-0 mt-1" />
                <span className="text-gray-400">Henderson & Durham, NC</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={20} className="text-red-500 flex-shrink-0" />
                <a href="tel:919-346-4803" className="text-gray-400 hover:text-red-500 transition-colors">
                  919-346-4803
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={20} className="text-red-500 flex-shrink-0" />
                <Link to="/contact" className="text-gray-400 hover:text-red-500 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 flex items-center justify-center gap-2">
            <span>© {new Date().getFullYear()} PUSH Training - NC. All rights reserved.</span>
            <Heart size={16} className="text-red-500" fill="currentColor" />
            <span>Saving Lives, One Training at a Time</span>
          </p>
          <Link to="/admin/login" className="text-gray-600 hover:text-gray-400 text-xs mt-3 inline-block transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
